import Hero4 from '../components/Hero4';
import Hero3 from '../components/Hero3';

import { Technical1Data,Technical2Data,Technical3Data,Technical4Data } from '../data/data.source';

const Technical = () => {
  return (<>
    <Hero3 data={Technical1Data}  />
    <Hero4 data={Technical2Data} imgleft />
    <Hero4 data={Technical3Data}  />
    <Hero4 data={Technical4Data} imgleft />
  </>
  );
};

export default Technical